<template>
  <div class="modal" v-bind:class="{ 'is-active': is_shown }">
    <div class="modal-background" @click="close_modal"></div>
    <div class="modal-card" style="width: calc(70% - 2em)">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t("system log") }}</p>
        <button class="delete" aria-label="close" @click="close_modal"></button>
      </header>
      <section class="modal-card-body">
        <pre><ol ref="console"></ol></pre>
        <!-- <textarea class="textarea" v-model="console"></textarea> -->
      </section>
      <footer class="modal-card-foot">
        <p class="buttons">
          <button class="button is-rounded" @click="close_modal">
            {{ $t("close") }}
          </button>
        </p>
      </footer>
    </div>
  </div>
</template>
<script>
import // create_socket,
// get,
// format_time,
// format_time,
//   post,
//   generate_error_message_text,
// change_active_tab,
"@/utils";
// import moment from "moment";

var socket = undefined;

export default {
  name: "EnterpriseModal",
  components: {},
  data() {
    return {
      is_shown: false,
      console: "",
    };
  },
  computed: {},
  methods: {
    close_modal() {
      let v = this;
      v.is_shown = false;
      socket.close();
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.is_shown = true;
      v.set_initial_state();

      // create_socket()
      //   .then((sckt) => {
      //     socket = sckt;

      //     socket.send(
      //       JSON.stringify({
      //         method: "system_log",
      //       })
      //     );

      //     socket.onmessage = (event) => {
      //       window
      //         .jQuery(v.$refs.console)
      //         .append(`<li>[${format_time(moment())}] ${event.data}</ li>`);
      //       v.console += `${event.data}\n`;
      //     };
      //   })
      //   .catch((err) => {
      //     console.error(err);
      //   });
    },
    set_initial_state() {
      this.console = "";
      socket = undefined;
      window.jQuery(this.$refs.console).empty();
    },
  },
  mounted() {
    // this.show_modal("42a7331a-099a-11ef-9b67-0800270c010e");
  },
};
</script>
<style></style>
